import React from 'react';
import { Collapse, Select, Switch, Row, Col } from 'antd';

const { Panel } = Collapse;
const { Option } = Select;

const PrintSettings = ({ printSettings, onChange }) => {
  const handlePrintableChange = (checked) => {
    onChange({ ...printSettings, printable: checked });
  };

  const handlePrintModeChange = (value) => {
    onChange({ ...printSettings, printMode: value });
  };

  const handlePaperSizeChange = (value) => {
    onChange({ ...printSettings, paperSize: value });
  };

  return (
    <Collapse style={{ margin: 5 }}>
      <Panel header="Print Settings">
        <Switch
          style={{ marginBottom: 12 }}
          checked={printSettings.printable}
          onChange={handlePrintableChange}
        >
          Printable
        </Switch>

        {printSettings.printable && (
          <>
            <Row align="middle" gutter={[16, 16]}>
              <Col span={4}>Paper Size</Col>
              <Col span={20}>
                <Select
                  showSearch
                  style={{ width: '100%' }}
                  placeholder="Select paper size"
                  onChange={handlePaperSizeChange}
                  value={printSettings.paperSize || undefined}
                >
                  <Option value="6x4">6x4 (DSP-620)</Option>
                  <Option value="5x7">5x7 (BRAVA21)</Option>
                  <Option value="4x6">4x6 (BRAVA21)</Option>
                  <Option value="6x8">6x8 (BRAVA21)</Option>
                </Select>
              </Col>
            </Row>

            <Row align="middle" gutter={[16, 16]}>
              <Col span={4}>Print Mode</Col>
              <Col span={20}>
                <Select
                  showSearch
                  style={{ width: '100%' }}
                  placeholder="Select print mode"
                  onChange={handlePrintModeChange}
                  value={printSettings.printMode || undefined}
                >
                  <Option value="2x2">2x2</Option>
                  <Option value="4x1">4x1</Option>
                </Select>
              </Col>
            </Row>
          </>
        )}
      </Panel>
    </Collapse>
  );
};

export default PrintSettings;
